import script from "./TextChat.vue?vue&type=script&setup=true&lang=js"
export * from "./TextChat.vue?vue&type=script&setup=true&lang=js"

import "./TextChat.vue?vue&type=style&index=0&id=86b8a0ba&lang=css"

const __exports__ = script;

export default __exports__